module.exports = __webpack_public_path__ + "static/media/regiao_sul.0b2f0afa.svg";